export default __webpack_public_path__ + "static/media/ies_Zeraus.2c9e4f8f.png";